import { excluirAlert } from 'app/services/alerts';
import recorrenciaApi from 'app/services/api/recorrenciaApi';
import { generateActionTypes, generateDefaultActions } from 'app/store/defaultReducer';

const RECORRENCIA = '[RECORRENCIA]';
const FECHAR_MODAL = `${RECORRENCIA}_FECHAR_MODAL`;
const VISUALIZAR_RECORRENCIA = `${RECORRENCIA}_VISUALIZAR`;
const PESQUISA_VENCIMENTO = `${RECORRENCIA}_PESQUISA_VENCIMENTO`;
const SET_DEFAULT_VALUE = `${RECORRENCIA}_SET_DEFAULT_VALUE`;

export const initRecorrencia = {
  origemLancamento: 'CONTA_PAGAR',
  dataVencimento: new Date(),
  dataEmissao: null,
  tipoDespesa: 'UNICA',
  competencia: null,
  fornecedor: null,
  favorecido: null,
  favorecidoDiferenteFornecedor: false,
  categorias: [{ classe: undefined, valorBruto: undefined, descricao: undefined, rateios: [] }],
  parcelamento: undefined,
  retencoes: undefined,
  repetirLancamento: false,
  frequencia: undefined,
  quantidade: undefined,
  numeroParcelas: undefined,
  linhaDigitavel: undefined,
};

const types = generateActionTypes(RECORRENCIA);

export const RecorrenciaTypes = {
  ...types,
  FECHAR_MODAL,
  VISUALIZAR_RECORRENCIA,
  PESQUISA_VENCIMENTO,
  SET_DEFAULT_VALUE,
};

function fecharModal(dispatch) {
  dispatch({
    type: RecorrenciaTypes.FECHAR_MODAL,
  });
  dispatch(RecorrenciaAction.buscar([]));
  dispatch(RecorrenciaAction.setInitialState());
}
function visualizarRecorrencia(payload = true) {
  return {
    type: RecorrenciaTypes.VISUALIZAR_RECORRENCIA,
    payload,
  };
}

const defaultActions = generateDefaultActions(RecorrenciaTypes);

async function carregarRegistros(dispatch, queryParams = {}) {
  try {
    dispatch(RecorrenciaAction.setCarregandoRegistros(true));
    const resp = await recorrenciaApi.buscar(queryParams);
    dispatch(RecorrenciaAction.buscar(resp.data));
  } finally {
    dispatch(RecorrenciaAction.setCarregandoRegistros(false));
  }
}
async function resgatar(dispatch, selecionados, tipoSelecao, search) {
  try {
    dispatch(RecorrenciaAction.setCarregandoRegistros(true));
    RecorrenciaAction.limparSelecao();

    const params = {
      ids: selecionados,
      tipoSelecao,
      dataVencimentoInicio: search?.dataVencimentoInicio?.format('YYYY-MM-DD'),
      dataVencimentoFim: search?.dataVencimentoFim?.format('YYYY-MM-DD'),
    };

    await recorrenciaApi.resgatar(params);
    carregarRegistros(dispatch);
  } finally {
    dispatch(RecorrenciaAction.setCarregandoRegistros(false));
  }
}

const filtroVencimento = (dataVencimentoInicio, dataVencimentoFim) => {
  return {
    type: PESQUISA_VENCIMENTO,
    payload: { dataVencimentoInicio, dataVencimentoFim },
  };
};

async function excluirRecorrencia(dispatch, id) {
  excluirAlert({
    opcoes: { title: 'Tem certeza que deseja excluir? Apenas a conta escolhida será excluída.' },
    confirmar: async () => {
      try {
        dispatch(RecorrenciaAction.setCarregandoRegistros(true));
        RecorrenciaAction.limparSelecao();

        const filtro = { ids: [id], tipoSelecao: 'NENHUM', recorrencia: true };

        await recorrenciaApi.deletar(filtro);
        carregarRegistros(dispatch);
      } finally {
        dispatch(RecorrenciaAction.setCarregandoRegistros(false));
        carregarRegistros(dispatch);
      }
    },
  });
}

const setInitialState = () => {
  return { type: SET_DEFAULT_VALUE };
};

export const RecorrenciaUtil = {};

export const RecorrenciaAction = {
  ...defaultActions,
  fecharModal,
  carregarRegistros,
  visualizarRecorrencia,
  resgatar,
  filtroVencimento,
  excluirRecorrencia,
  setInitialState,
};
